import { render, staticRenderFns } from "./schoolEventsListing.vue?vue&type=template&id=7f40a910"
import script from "./schoolEventsListing.vue?vue&type=script&lang=js"
export * from "./schoolEventsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports